import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g data-name=\"Layer 2\"><path fill=\"none\" d=\"M0 0h48v48H0z\" data-name=\"invisible box\"></path><g data-name=\"icons Q2\"><path d=\"m19.6 32.4-4-3.9a2.1 2.1 0 0 1-.2-2.7 1.9 1.9 0 0 1 3-.2l2.6 2.6 8.6-8.6a2 2 0 0 1 2.8 2.8l-10 10a1.9 1.9 0 0 1-2.8 0Z\"></path><path d=\"M24 12A15 15 0 1 1 9 27a15 15 0 0 1 15-15m0-4a19 19 0 1 0 19 19A19 19 0 0 0 24 8ZM6 12a2.1 2.1 0 0 1-1.6-.8 2 2 0 0 1 .4-2.8l8-6a2 2 0 0 1 2.8.4 2 2 0 0 1-.4 2.8l-8 6A1.9 1.9 0 0 1 6 12ZM42 12a1.9 1.9 0 0 1-1.2-.4l-8-6a2 2 0 0 1-.4-2.8 2 2 0 0 1 2.8-.4l8 6a2 2 0 0 1 .4 2.8 2.1 2.1 0 0 1-1.6.8Z\"></path></g></g>", 1)
  ]))]))
}
export default { render };